module.exports = __webpack_public_path__ + "static/media/logo_instagram.268235ed.svg";